wbApp.controller('SentEmailsCtrl', ['$scope', '$translate', '$filter', 'sentEmailsSvc',
function ($scope, $translate, $filter, sentEmailsSvc) {

    $scope.selectedGroup = [];

    $scope.gridSettings = {
        columns: [
            {
                dataField: 'recipients',
                caption: $translate.instant('TXT_LBL_RECIPIENTS'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return _.map(_.filter(rowData.emails, 'name'), 'name').join(', ');
                },
                width: '240px'
            },
            { dataField: 'subject', caption: $translate.instant('TXT_EMAIL_SUBJECT'), dataType: 'string' },            
            {
                dataField: 'status',
                caption: $translate.instant('TXT_LBL_STATE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('emailGroupStatus')(rowData.status);
                },
                width: '120px'
            },
            {
                dataField: 'updatedAt',
                caption: $translate.instant('TXT_LBL_UPDATED_AT'),
                dataType: 'date',
                format: 'shortDateShortTime',
                width: '130px',
                sortOrder: 'desc'
            }
        ]
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedGroup = data.emails;        
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.emails = sentEmailsSvc.getSummary();
        $scope.selectedGroup = [];
    });

    $scope.emails = sentEmailsSvc.getSummary();

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "messages/sent-emails-tabs-group-detail.html"
    },{
        title: 'TXT_STATISTICS',
        template: "messages/sent-emails-tabs-statistics.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });
}]);
